/**
 * WorkflowSessionContext.tsx — Workflow store React 上下文
 *
 * 职责：
 *     向 WorkflowSession 子树注入 workflowSessionStore。
 *
 * 链路位置：
 *     WorkflowSession Provider。
 *
 * 当前裁剪范围：
 *     与 SessionStoreContext 平行，不混用。
 */
import { createContext, useContext } from 'react';
import { useStore } from 'zustand';

import type { SessionStatus } from '../../types/tree';
import type { WorkflowSessionStore } from '../workflowSessionStore';

export const WorkflowSessionStoreContext = createContext<WorkflowSessionStore | null>(null);

export function useWorkflowSessionStoreApi(): WorkflowSessionStore {
  const store = useContext(WorkflowSessionStoreContext);
  if (!store) {
    throw new Error('useWorkflowSessionStoreApi must be used within WorkflowSession');
  }
  return store;
}

export function useWorkflowSessionStatus(): SessionStatus {
  const store = useWorkflowSessionStoreApi();
  return useStore(store, (s) => s.state.status);
}
